import { ExportScope } from './export-scope.entity';

export interface RejectionReportRequest {
    Q?: string;
    SubjectIds?: string[];
}

export function toRejectionReportRequest(scope: ExportScope): RejectionReportRequest {
    return scope.kind === 'filtered' ? { Q: scope.q } : { SubjectIds: scope.subjectIds };
}

export interface RejectionReport {
    readonly csv: string;
    readonly hasRejections: boolean;
}
